import View from "../framework/view";
import template from "../../pugc/shop-products";
import Server from "../server";
import {Product} from "../bo/product";
import {EditProductNotification} from "./wrb";
import {NEW_PRODUCT} from "./shop_product";
import jQuery from "jquery";
import {Collection} from "../bo/collection";

const classname = "shop-products-view";

const server = Server.instance();

export class ShopProductsView extends View {

    private products?: Product[];

    private suppress_from_price: boolean = true;

    private collections: Collection[] = [];

    private collection: Collection | null = null;

    private selected: {[key: string]: boolean} = {};

    constructor() {
        super(classname);
        this.load();
    }

    async load() {
        let products = await server.products();
        this.suppress_from_price = await server.getSupressFrom();

        this.collections = await server.collections();

        // take copy before sorting
        products = products.slice();
        products.sort((a, b) => {
            return (a.name || "").localeCompare(b.name || "");
        });
        this.products = products;

        this.update();
    }

    private getDisplayedProducts() {
        let products = this.products ? [ ...this.products ] : [];

        if (this.collection) {
            const c = this.collection;
            const id = c.id as string;
            products = products.filter(p => {
                const ids = p.collectionIds || [];
                const idx = ids.indexOf(id);
                return idx >= 0;
            });
        }

        return products;
    }

    protected render0(): JQuery<HTMLElement> {

        const products = this.getDisplayedProducts();

        const selected: any = {};
        for (const p of products) {
            if (p.name !== undefined && this.selected[p.name]) {
                selected[p.name] = true;
            }
        }

        const data = {
            products: products,
            suppress_from_price: this.suppress_from_price,
            collections: this.collections,
            collection: this.collection,
            selected: selected,
        };

        const out = this.pug(template, data);
        return out;
    }

    addProduct() {
        this.notify(new EditProductNotification(NEW_PRODUCT));
    }

    async setSuppressFromPrice(f: boolean) {
        await server.setSupressFrom(f);
        this.suppress_from_price = f;
        this.update();
    }

    setCollection(id: string) {
        const c = this.collections.filter(x => x.id == id);
        this.collection = c[0] || null;
        this.update();
    }

    setSelected(name: string, val: boolean) {
        if (val) {
            this.selected[name] = true;
        } else {
            delete this.selected[name];
        }
        this.update(".actions");
    }

    async hideSelected(hide: boolean) {
        const products = this.getDisplayedProducts().filter(p => p.name !== undefined && this.selected[p.name]);
        server.hideProducts(products.map(p => p.name as string), hide);
        await this.load();
    }
}

View.on(
    "." + classname,
    "click",
    ".add-product",
    function(that: ShopProductsView, event, elt) {
        event.preventDefault();
        that.addProduct();
    });

View.on(
    "." + classname,
    "change",
    "input[name=suppress_from_price]",
    function(that: ShopProductsView, event, elt) {
        event.preventDefault();
        const f = jQuery(elt).is(":checked");
        that.setSuppressFromPrice(f);
    });

View.on(
    "." + classname,
    "change",
    "select[name=collection]",
    function(that: ShopProductsView, event, elt) {
        event.preventDefault();
        const id = jQuery(elt).val() as string;
        that.setCollection(id);
    });

View.on(
    "." + classname,
    "change",
    "input.product-select",
    function(that: ShopProductsView, event, elt) {
        event.preventDefault();
        const val = jQuery(elt).is(":checked");
        const name = jQuery(elt).data("product") as string;
        that.setSelected(name, val);
    });

View.on(
    "." + classname,
    "click",
    "button.hide-selected",
    function(that: ShopProductsView, event, elt) {
        event.preventDefault();
        that.hideSelected(true);
    });

View.on(
    "." + classname,
    "click",
    "button.unhide-selected",
    function(that: ShopProductsView, event, elt) {
        event.preventDefault();
        that.hideSelected(false);
    });

